import React, { useContext, useEffect, useState } from "react";
import {
  Collapse,
  Group,
  ActionIcon,
  TextInput,
  Flex,
  Checkbox,
  Text,
  Box,
  Tooltip,
  Stack
} from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons";
import { SplitButton } from "../../general/SplitButton";
// import IdeasContext from "../IdeasContext"; // Removed - using props instead
import { showNotification } from "@mantine/notifications";
import FiltersMenuWrapper from "./FiltersMenuWarper";
import SearchPanel from "./SearchPanel";
import { getConnectedUserRole, isBagelAdmin } from "../../../utils";
import { useAuth0 } from "@auth0/auth0-react";
import FiltersContext from "../filters/context/FiltersContext";
import { editSubpage } from "../../../Api";
import { SyncContext } from "../../../context/SyncContext";
interface FilterActionsProps {
  activeFilters: any[];
  setActiveFilters: (filters: any[]) => void;
  selectedView: any;
  open: () => void;
  handleSaveViews: () => void;
  opened: boolean;
  viewName: string;
  setViewName: (name: string) => void;
  doClose: () => void;
  toggle: () => void;
  search: string;
  setSearch: (search: string) => void;
  searchOpened: boolean;
  setSearchOpened: (opened: boolean) => void;
  actionIconsRef: React.MutableRefObject<any>
  isGlobal: boolean;
  setIsGlobal: (isGlobal: boolean) => void;
  isSubPageView: boolean;
  setIsSubPageView: (isSubPageView: boolean) => void;
  sortState: string;
  setSortState: (state: string) => void;
}

const FilterActions: React.FC<FilterActionsProps> = ({
  activeFilters,
  setActiveFilters,
  selectedView,
  open,
  handleSaveViews,
  opened,
  viewName,
  setViewName,
  doClose,
  toggle,
  search,
  setSearch,
  searchOpened,
  setSearchOpened,
  actionIconsRef,
  isGlobal,
  setIsGlobal,
  isSubPageView,
  setIsSubPageView,
  sortState,
  setSortState
}) => {
  // Remove IdeasContext dependency since we pass upsertView via handleSaveViews now
  const { fields, setFields } = useContext(SyncContext);
  const { subPageKey, editMode } = useContext(FiltersContext);
  const subPage = fields?.subPages?.find((subPage: any) => subPage.key === subPageKey);
  const auth0 = useAuth0();
  const role = getConnectedUserRole(auth0);
  const canEdit = role === "admin";

  const [value, setValue] = useState<string[]>(['assigned', 'suggested']);
  useEffect(() => {
    const newSortState = (value.length === 2 || value.length === 0) ? 'total' : value[0];
    if (sortState !== newSortState) {
      setSortState(newSortState);
      if (process.env.NODE_ENV === 'development') {
        console.log('🎛️ Sort state changed:', { from: sortState, to: newSortState, checkboxes: value });
      }
    }
  }, [value, sortState, setSortState]); 

  return (
    <Collapse in={true} my={12}>
      <Group my={18.2}  position="apart"  noWrap align="center">
        <Flex>
          <Group>
            <FiltersMenuWrapper
              activeFilters={activeFilters}
              setActiveFilters={setActiveFilters}
              selectedView={selectedView}
              MenuType="idea"
            />

            <FiltersMenuWrapper
              activeFilters={activeFilters}
              setActiveFilters={setActiveFilters}
              selectedView={selectedView}
              MenuType="evidence"
              targetSx={{
                marginLeft: 1
              }}
            />
          </Group>
          <Group spacing={4} noWrap mx='md'>
            <Box ref={actionIconsRef} mr={6}>
              <SearchPanel
                toggle={toggle}
                search={search}
                setSearch={setSearch}
                searchOpened={searchOpened}
                setSearchOpened={setSearchOpened}
              />
            </Box>
            { editMode && canEdit && 
            <SplitButton
              isSplit={(subPageKey && subPage?.defaultFilters?.length) ? true : (fields?.defaultFilters?.length ? true : false)}
              lable={"Save as page filter    "}
              sx= {{backgroundColor: "#fa5252"}}
              onClick={() => {
                // Create unique filters by name and add default: true
                const uniqueFiltersWithDefault = activeFilters.reduce((acc: any[], filter: any) => {
                  const existingIndex = acc.findIndex((f: any) => f.name === filter.name);
                  if (existingIndex === -1) {
                    // Add new filter with default: true
                    acc.push({
                      ...filter,
                      default: true
                    });
                  } else {
                    // Update existing filter with default: true
                    acc[existingIndex] = {
                      ...filter,
                      default: true
                    };
                  }
                  return acc;
                }, []);

                editSubpage( auth0,
                  { filters: activeFilters, subPageKey: subPageKey })
                  .then((res) => {
                    // Update the specific subpage in subPages array
                    const updatedSubPages = fields?.subPages?.map((page: any) => 
                      page.key === subPageKey 
                        ? { ...page, defaultFilters: activeFilters }
                        : page
                    );
                    if(fields){
                      setFields({...fields, subPages: updatedSubPages});
                    }
                    
                    setActiveFilters(uniqueFiltersWithDefault);
                    showNotification({
                      title: "Saved successfully!",
                      color: "teal",
                      message: "Filter saved successfully",
                      icon: <IconCheck size="1.1rem" />,
                      autoClose: 1200
                    });
                  })
                  .catch((err) => {
                    showNotification({
                      title: "Error",
                      color: "red",
                      message: "Error saving filter",
                    });
                  });
              }}
              items={[
                {
                  disabled: activeFilters.length === 0,
                  id: "close",
                  onClick: () => {
                    editSubpage( auth0,
                      { filters: [], subPageKey: subPageKey })
                      .then((res) => {
                        console.log(res);
                        const nonDefaultFilters = activeFilters.filter((filter: any) => !filter.default);
                        setActiveFilters(nonDefaultFilters);
                        
                        // Update the specific subpage in subPages array
                        const updatedSubPages = fields?.subPages?.map((page: any) => 
                          page.key === subPageKey 
                            ? { ...page, defaultFilters: [] }
                            : page
                        );
                        if(fields){
                          setFields({...fields, subPages: updatedSubPages});
                        }
                        showNotification({
                          title: "Default filters removed",
                          color: "blue",
                          message: "Default filters have been removed",
                          icon: <IconX size="1.1rem" />,
                          autoClose: 1200
                        });
                      })
                      .catch((err) => {
                        showNotification({
                          title: "Error",
                          color: "red",
                          message: "Error saving filter",
                        });
                      });
                  },
                  name: "Remove page filters",
                },
              ]}
              disabled={activeFilters.length === 0}
            /> 
            }
            {selectedView?.isGlobal && 
            <SplitButton
              isSplit={false}
              lable={
                !opened
                  ? "Save as new view"
                  : !selectedView?.isGlobal
                    ? "Save view"
                    : "Save"
              }
              onClick={() => {
                console.log({
                  selectedView,
                  elseif: !selectedView?.isGlobal && !opened,
                });
                if (!opened) {
                  open();
                } else if (opened) {
                  handleSaveViews();
                } else if (!selectedView?.isGlobal && !opened) {
                  // Handle save via parent component
                  handleSaveViews();
                }
              }}
              items={[
                {
                  id: "1",
                  onClick: () => open(),
                  name: "Save as new view",
                },
              ]}
              disabled={activeFilters.length === 0}
            /> 
            }

            {/* New view name input */}
            {opened && (
              <>
                <TextInput
                  value={viewName}
                  onChange={(event) => setViewName(event.currentTarget.value)}
                  placeholder="View name"
                  size="xs"
                />
                {canEdit && (
                  <Tooltip
                    label="Visible to all"
                    position="top"
                    withArrow
                  >
                    <Stack spacing={4}>
                      <Text size="xs" color="dimmed" mt={-24}>Visible to all</Text>
                      <Checkbox
                        color="indigo"
                        value='visible'
                        sx={{
                          width: '2px',
                          height: '2px',
                          marginLeft: '24px',
                          marginTop: '-7px',
                        }}
                        checked={isGlobal}
                        onChange={(event) => setIsGlobal(event.currentTarget.checked)}
                      /> 
                    </Stack>
                  </Tooltip>
                )}
                {canEdit && (
                  <Tooltip
                    label="Add to sub-pages"
                    position="top"
                    withArrow
                  >
                    <Stack spacing={4}>
                      <Text size="xs" color="dimmed" mt={-24} ml={10}>Add to sub-pages</Text>
                      <Checkbox
                        color="indigo"
                        value='subpages'
                        sx={{
                          width: '2px',
                          height: '2px',
                          marginLeft: '40px',
                          marginTop: '-7px',
                        }}
                        checked={isSubPageView}
                        onChange={(event) => setIsSubPageView(event.currentTarget.checked)}
                      /> 
                    </Stack>
                  </Tooltip>
                )}
                <ActionIcon sx={{ height: 32 }} onClick={doClose}>
                  <IconX size={14} />
                </ActionIcon>
              </>
            )}



          </Group> 
        </Flex>
        <Flex align='center'>

          
        
          <Flex /* mr={80} */>
            <Checkbox.Group
              value={value}
              onChange={(values: string[]) => {
                if (values.length > 0) setValue(values);
              }}
            >
              <Flex gap="md"> {/* Wrap the checkboxes in a Flex with horizontal gap */}
                <Checkbox 
                  size='xs'
                  color="indigo" 
                  value='assigned' 
                  label={
                    <Flex align='center'>
                      <Box
                        sx={{
                          width: 5.64,
                          height: 5.64,
                          borderRadius: '50%',
                          backgroundColor: "#5C5CEB",
                        }}
                        ml={-3}
                        mr={8}
                        
                      />
                      <Text color="#5C5CEB" mt={-1}>Assigned</Text>
                    </Flex>
                  }
                />

                <Checkbox 
                  color="indigo" 
                  value='suggested' 
                  label={
                    <Flex align='center'>
                      <Box
                        sx={{
                          width: 5.7,
                          height: 5.7,
                          borderRadius: '50%',
                          backgroundColor: "rgba(92, 92, 235, 0.6)",
                        }}
                        ml={-3}
                        mr={8}
                      />
                      <Text color="rgba(92, 92, 235, 0.8)" mt={-1}>Suggested</Text>
                    </Flex>
                  }
                />
              </Flex>
            </Checkbox.Group>
          </Flex>

        </Flex>
        
      </Group>
    </Collapse>
  );
};

export default FilterActions;
